import { User } from 'firebase'
import { NOUSER } from 'providers/User'

export const shouldSignin = (user: User | null /* NOT LOGGED IN */ | undefined /* USER IS NOT LOADED */) => {
  return user === NOUSER
}
